export default __webpack_public_path__ + "daa19ea734a39c90c0123b9d53421af0.png";